import { render } from "./AdjustmentTab.vue?vue&type=template&id=1a9a9020"
import script from "./AdjustmentTab.vue?vue&type=script&lang=js"
export * from "./AdjustmentTab.vue?vue&type=script&lang=js"

import "./AdjustmentTab.vue?vue&type=style&index=0&id=1a9a9020&lang=css"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__